import { Bell, ChevronDown } from "lucide-react";
import type { AppContextOption, AppIdentity } from "@/app/types";
import { firstName, getTimeGreeting } from "@/shared/lib/greeting";
import { ProfileAvatar } from "@/shared/components/ProfileAvatar";

export function UserHeader({ identity, context, onContextClick, onNotificationsClick, unreadNotifications = 0 }: { identity: AppIdentity; context: AppContextOption; onContextClick: () => void; onNotificationsClick: () => void; unreadNotifications?: number }) {
  return <header className="safe-top app-root-header relative z-20 overflow-visible px-5">
    <div className="mx-auto max-w-lg overflow-visible">
      <div className="flex min-h-[46px] items-center justify-between overflow-visible">
        <div className="brand-lockup-premium brand-lockup-compact" aria-label="YamarHub APP">
          <img src="/brand/yamar-symbol-dark.svg" alt="" aria-hidden className="brand-symbol" />
          <span className="brand-name"><strong>Yamar</strong><em>Hub</em><span className="brand-product-badge">APP</span></span>
        </div>

        <button onClick={onNotificationsClick} aria-label="Notificações" className="glass-icon relative flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
          <Bell className="h-[18px] w-[18px]"/>
          {unreadNotifications > 0 && <span className="absolute -right-0.5 -top-0.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-teal px-1 text-[9px] font-bold text-ink">{unreadNotifications > 99 ? "99+" : unreadNotifications}</span>}
        </button>
      </div>

      <button onClick={onContextClick} className="app-context-trigger mt-2 flex w-full items-center gap-2.5 rounded-2xl px-1.5 py-2 text-left" aria-label="Trocar academia ou experiência">
        <ProfileAvatar src={identity.photoUrl} name={identity.name} size="md" ring className="shadow-[0_0_22px_rgba(15,163,154,.12)]"/>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5">
            <span className="truncate font-display text-[15px] font-semibold text-white">{getTimeGreeting()}, {firstName(identity.name)}</span>
            <ChevronDown className="h-3.5 w-3.5 shrink-0 text-white/40"/>
          </div>
          <p className="mt-0.5 truncate text-[11px] text-white/48"><span className="font-semibold text-teal-light/90">{context.label}</span><span aria-hidden="true"> · </span>{context.tenantName}</p>
        </div>
      </button>
    </div>
  </header>;
}
